export default function search() {
    const overlay = $('.search-overlay');
    const nav = $('nav.main');
    const search = overlay.find('.search');
    const autocomplete = $('.algolia-autocomplete');

    nav.find('.search-toggle').on('click', e => {
        e.preventDefault();
        overlay.removeClass('hidden')
        nav.trigger('nav-close');
        setTimeout(() => search.focus(), 400);
    });

    overlay.on('click', e => {
        if (e.target == overlay[0]) {
            overlay.addClass('hidden');
            autocomplete.hide();
        }
    });

    $(document).on('keydown', e => {
        if (e.which == 27 && !autocomplete.is(':visible')) {
            overlay.addClass('hidden');
        }
    });
}
